<template>
  <div class="settings component">
    <UiDataBox :loading="loading" :error="error">
      <section class="profile">
        <div class="title">Profile info:</div>
        <div class="form-control">
          <label for="email">email</label>
          <input id="email" type="text" v-model="user.email" placeholder="email" readonly>
        </div>
        <div class="form-control">
          <label for="name">name</label>
          <input id="name" type="text" v-model="user.name" placeholder="name">
        </div>
        <div class="form-control">
          <label for="role">role</label>
          <input id="role" type="text" v-model="user.role" placeholder="role" readonly>
        </div>
        <div class="form-control button">
          <md-button @click="updateProfile" :disabled="isSaveProfileDisabled">Save profile</md-button>
        </div>
      </section>

      <section class="password">
        <div class="title">Change password:</div>
        <div class="form-control">
          <label for="oldPassword">old password</label>
          <input id="oldPassword" type="password" v-model="password.oldPassword" placeholder="password">
        </div>
        <div class="form-control">
          <label for="newPassword">new password (8 characters min)</label>
          <input id="newPassword" type="password" v-model="password.newPassword" placeholder="new password">
        </div>
        <div class="form-control">
          <label for="repeatNewPassword">repeat new password</label>
          <input id="repeatNewPassword" type="password" v-model="password.repeatNewPassword" placeholder="repeat new password">
        </div>

        <div class="form-control button">
          <md-button @click="changePassword" :disabled="isSavePasswordDisabled">Save password</md-button>
        </div>
      </section>
    </UiDataBox>
  </div>
</template>

<script>
  import * as usersService from '../../services/user.service'
  import * as authService from '../../services/auth.service'

  import setModelMixin from '../../mixins/setModelMixin'

  export default {
    name: 'Settings',
    props: {},
    components: {},
    mixins: [setModelMixin],
    data () {
      return {
        loading: false,
        error: false,
        user: {
          id: '',
          email: '',
          name: '',
          role: ''
        },
        password: {
          oldPassword: '',
          newPassword: '',
          repeatNewPassword: ''
        }
      }
    },
    methods: {
      updateProfile () {
        this.loading = true
        usersService.update(this.user.id, {name: this.user.name})
          .then(response => {
            this.user = this.setModelMixin(this.user, response.data)
            this.$snotify.success('Profile is saved', 'All done!')
          }).catch(error => {
            console.log(error)
            this.$snotify.error(error.message, 'Error')
          }).finally(() => { this.loading = false })
      },
      changePassword () {
        const data = {
          oldPassword: this.password.oldPassword,
          newPassword: this.password.newPassword
        }

        this.loading = true
        usersService.changePassword(data)
          .then(() => {
            authService.makeLogout()
            this.$snotify.success('Password is changed, please authorise again', 'All done!')
          }).catch(error => {
            console.log(error)
            this.$snotify.error(error.message, 'Error')
          }).finally(() => { this.loading = false })
      }
    },
    computed: {
      isSaveProfileDisabled () {
        return (this.user.name.length < 3) || this.loading
      },
      isSavePasswordDisabled () {
        return (this.password.newPassword.length < 8) || (this.password.newPassword !== this.password.repeatNewPassword) || this.loading
      }
    },
    mounted () {
      this.user = this.$currentUser
    }
  }
</script>

<style lang="scss" scoped>
  .settings.component {
    padding: 10px;

    .title {
      font-size: 14px;
      font-weight: 800;
      text-transform: uppercase;
      padding: 20px 0;
    }

    .form-control.button {
      display: flex;
      justify-content: flex-end;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/profile/Settings.vue